import { Auth0Provider } from "@auth0/auth0-react";

import { PROVIDER_SCOPE, getWfAuth0Config, isWfAuthnMockEnabled } from "../lib/config";

import { Auth0SessionRefresher } from "./Auth0SessionRefresher";

interface WfAuth0ProviderProps {
  clientId: string;
  domain: string;
  defaultAudience?: string;
  withSessionRefresher?: boolean;

  children?: React.ReactNode;
}

const WfAuth0Provider = (props: WfAuth0ProviderProps) => {
  const withSessionRefresher = !isWfAuthnMockEnabled();

  return (
    <Auth0Provider
      authorizationParams={{
        audience: props.defaultAudience ?? "wayflyer",
        redirect_uri: window.location.origin,
        scope: PROVIDER_SCOPE,
      }}
      cacheLocation="localstorage"
      clientId={props.clientId}
      domain={props.domain}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      skipRedirectCallback={true}
    >
      {props.withSessionRefresher ?? withSessionRefresher ? <Auth0SessionRefresher /> : null}
      {props.children}
    </Auth0Provider>
  );
};

export function WfAuth0ProviderFromViteConfig({ children }: { children: React.ReactNode }) {
  const config = getWfAuth0Config();

  return (
    <WfAuth0Provider clientId={config.clientId} domain={config.domain}>
      {children}
    </WfAuth0Provider>
  );
}
